import { render, staticRenderFns } from "./persinnelDetail.vue?vue&type=template&id=43d62b14&scoped=true"
import script from "./persinnelDetail.vue?vue&type=script&lang=js"
export * from "./persinnelDetail.vue?vue&type=script&lang=js"
import style0 from "./persinnelDetail.vue?vue&type=style&index=0&id=43d62b14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d62b14",
  null
  
)

export default component.exports